/* De Emblemenfabriek · naamgenerator v1. Prices/stock come from Shopify Liquid. */
(function (global) {
  'use strict';
  function normalize(value) {
    return String(value || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  }
  function quantities(text) {
    const counts = {};
    for (const letter of text) if (/[A-Z]/.test(letter)) counts[letter] = (counts[letter] || 0) + 1;
    return counts;
  }
  function tier(count, discounts) {
    const index = count >= 10 ? 2 : count >= 5 ? 1 : count >= 2 ? 0 : -1;
    return { minimum: index < 0 ? 0 : [2, 5, 10][index], rate: index < 0 ? 0 : Number(discounts[index]) };
  }
  function model(value, config, cartItems) {
    const text = normalize(value);
    const counts = quantities(text);
    const count = Object.values(counts).reduce((sum, n) => sum + n, 0);
    const products = new Map(config.products.map(p => [p.letter, p]));
    const existing = {};
    const ids = new Set(config.products.map(p => Number(p.id)));
    let cartCount = 0;
    for (const item of cartItems || []) {
      const id = Number(item.variant_id || item.id);
      if (ids.has(id)) { existing[id] = (existing[id] || 0) + item.quantity; cartCount += item.quantity; }
    }
    const errors = [];
    if (/[^A-Z ]/.test(text)) errors.push('Gebruik alleen letters A–Z en spaties. Cijfers en leestekens zijn geen letteremblemen.');
    if (!count) errors.push('Typ eerst je naam of tekst.');
    if (count > config.maxLetters) errors.push('Kies maximaal ' + config.maxLetters + ' letters per tekst.');
    const missing = Object.keys(counts).filter(letter => !products.has(letter));
    if (missing.length) errors.push('Deze letters zijn nog niet beschikbaar in de collectie: ' + missing.join(', ') + '.');
    const lines = Object.entries(counts).filter(([letter]) => products.has(letter)).map(([letter, quantity]) => ({ product: products.get(letter), quantity }));
    const delayed = [];
    for (const line of lines) {
      const p = line.product;
      const combined = line.quantity + (existing[p.id] || 0);
      if (!p.available || (p.tracked && p.policy !== 'continue' && combined > Math.max(0, p.stock))) errors.push('Letter ' + p.letter + ' is niet in de gevraagde hoeveelheid leverbaar.');
      else if (p.tracked && p.policy === 'continue' && combined > Math.max(0, p.stock)) delayed.push(p.letter);
    }
    const chosen = config.discountEnabled ? tier(count + cartCount, config.discounts) : { minimum: 0, rate: 0 };
    const subtotal = lines.reduce((sum, line) => sum + line.quantity * line.product.price, 0);
    const estimated = Math.round(subtotal * (100 - chosen.rate) / 100);
    return { text, counts, count, lines, errors, delayed, subtotal, estimated, tier: chosen, cartCount, valid: errors.length === 0 };
  }

  // Coordinates calibrated for ef-feestjasje-blanco.png; letter height ~5 cm on a ~95 cm coat.
  // Normalized photo width/height units, so resizing never changes the proportions.
  function jacketLayout(text, ratios) {
    const height = 0.0384, gap = 0.0032, space = 0.0144, maxWidth = 0.40, maxRows = 4;
    const tokens = [...text].map(letter => ({ letter, width: letter === ' ' ? space : height * (ratios[letter] || 0.7) }));
    const rows = [];
    let row = [], width = 0;
    function commit() {
      while (row.length && row[row.length - 1].letter === ' ') row.pop();
      if (row.length) rows.push(row);
      row = []; width = 0;
    }
    // Prefer a word break when one complete word can fit; split long words at letter boundaries.
    const words = text.split(' ').filter(Boolean);
    for (const word of words) {
      const parts = [...word].map(letter => tokens.find(t => t.letter === letter));
      const wordWidth = parts.reduce((sum, part) => sum + part.width, 0) + gap * Math.max(0, parts.length - 1);
      if (row.length && wordWidth <= maxWidth && width + space + wordWidth > maxWidth) commit();
      if (row.length) { row.push({ letter: ' ', width: space }); width += space; }
      for (const part of parts) {
        const advance = part.width + (row.length && row[row.length - 1].letter !== ' ' ? gap : 0);
        if (row.length && width + advance > maxWidth) commit();
        if (part.width > maxWidth) return { fits: false, rows: 0, patches: [] };
        if (row.length && row[row.length - 1].letter !== ' ') width += gap;
        row.push(part); width += part.width;
      }
    }
    commit();
    if (rows.length > maxRows) return { fits: false, rows: rows.length, patches: [] };
    const patches = [];
    rows.forEach((parts, index) => {
      const total = parts.reduce((sum, part) => sum + part.width, 0) + parts.reduce((sum, part, i) => sum + (i && part.letter !== ' ' && parts[i - 1].letter !== ' ' ? gap : 0), 0);
      let x = (1 - total) / 2;
      parts.forEach((part, i) => {
        if (i && part.letter !== ' ' && parts[i - 1].letter !== ' ') x += gap;
        if (part.letter !== ' ') patches.push({ letter: part.letter, x, y: 0.205 + index * (height + 0.0104), width: part.width, height });
        x += part.width;
      });
    });
    return { fits: true, rows: rows.length, patches };
  }

  const core = { normalize, quantities, tier, model, jacketLayout };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (typeof document === 'undefined') return;
  if (global.EFNameGeneratorLoaded) return;
  global.EFNameGeneratorLoaded = true;
  const imageCache = new Map();
  function loadPatch(url) {
    if (imageCache.has(url)) return imageCache.get(url);
    const task = new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      const timeout = setTimeout(() => reject(new Error('image timeout')), 10000);
      image.onerror = () => { clearTimeout(timeout); reject(new Error('image unavailable')); };
      image.onload = () => {
        clearTimeout(timeout);
        try {
          const source = document.createElement('canvas');
          source.width = image.naturalWidth; source.height = image.naturalHeight;
          const context = source.getContext('2d', { willReadFrequently: true });
          context.drawImage(image, 0, 0);
          const pixels = context.getImageData(0, 0, source.width, source.height).data;
          let left = source.width, top = source.height, right = -1, bottom = -1;
          for (let y = 0; y < source.height; y++) for (let x = 0; x < source.width; x++) {
            if (pixels[(y * source.width + x) * 4 + 3] > 20) {
              left = Math.min(left, x); right = Math.max(right, x); top = Math.min(top, y); bottom = Math.max(bottom, y);
            }
          }
          if (right < left) throw new Error('empty image');
          const canvas = document.createElement('canvas');
          const h = bottom - top + 1, w = right - left + 1;
          canvas.height = 160; canvas.width = Math.max(1, Math.round(w / h * 160));
          canvas.getContext('2d').drawImage(image, left, top, w, h, 0, 0, canvas.width, canvas.height);
          resolve(canvas);
        } catch (error) { reject(error); }
      };
      image.src = url;
    });
    imageCache.set(url, task);
    return task;
  }
  function cloneCanvas(original) {
    const canvas = document.createElement('canvas');
    canvas.width = original.width; canvas.height = original.height;
    canvas.getContext('2d').drawImage(original, 0, 0);
    canvas.style.width = (original.width / original.height * 56) + 'px';
    return canvas;
  }
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-config]').textContent);
    const $ = selector => root.querySelector(selector);
    const buttons = [...root.querySelectorAll('[data-buy]')];
    const input = $('[data-text]'), preview = $('[data-preview]');
    const sticky = $('[data-sticky]'), mini = $('[data-sticky-preview]');
    const money = amount => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: config.currency }).format(amount / 100);
    let cartItems = [], busy = false, locked = false, generation = 0, state;
    const base = global.Shopify && global.Shopify.routes ? global.Shopify.routes.root : '/';
    const cartUrl = config.cartUrl || base + 'cart';
    let mainVisible = true;
    function setSticky() { sticky.hidden = mainVisible || !state || !state.count; }
    const observer = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(entries => {
      mainVisible = entries[0].isIntersecting; setSticky();
    }, { threshold: 0 }) : null;
    if (observer) observer.observe(buttons[0]);

    async function paintJacket(text, version) {
      const frames = [...root.querySelectorAll('[data-jacket]')];
      const notes = [...root.querySelectorAll('[data-jacket-note]')];
      const pools = frames.map(frame => frame.querySelector('[data-jacket-letters]'));
      pools.forEach(pool => pool.replaceChildren());
      if (!frames.length) return;
      frames.forEach(frame => frame.setAttribute('aria-label', 'Jaspreview van ' + text));
      const setNote = message => notes.forEach(note => { note.textContent = message; });
      if (!text) { setNote('Typ je tekst om de letters op het jasje te bekijken.'); return; }
      if (/[^A-Z ]/.test(text)) { setNote('De jaspreview ondersteunt letters A–Z en spaties.'); return; }
      setNote('We plaatsen jouw echte letters op het jasje…');
      const sources = new Map();
      await Promise.all([...new Set(text.replace(/ /g, ''))].map(async letter => {
        const p = config.products.find(p => p.letter === letter);
        if (!p || !p.image) return;
        try { sources.set(letter, await loadPatch(p.image)); } catch (_) {}
      }));
      if (version !== generation || !root.isConnected) return;
      const missing = [...new Set(text.replace(/ /g, ''))].filter(letter => !sources.has(letter));
      if (missing.length) { setNote('Nog geen volledige jaspreview: afbeelding van ' + missing.join(', ') + ' ontbreekt. Het letteroverzicht hieronder blijft beschikbaar.'); return; }
      const ratios = {};
      for (const [letter, source] of sources) ratios[letter] = source.width / source.height;
      const layout = jacketLayout(text, ratios);
      if (!layout.fits) { setNote('Deze tekst past bij circa 5 cm letterhoogte niet op het vrije rugvlak van dit voorbeeldjasje. Bekijk de losse letters en kies zelf een andere indeling.'); return; }
      for (const patch of layout.patches) {
        const source = sources.get(patch.letter);
        for (const pool of pools) {
          const canvas = cloneCanvas(source);
          canvas.style.left = patch.x * 100 + '%'; canvas.style.top = patch.y * 100 + '%';
          canvas.style.width = patch.width * 100 + '%'; canvas.style.height = patch.height * 100 + '%';
          canvas.setAttribute('aria-hidden', 'true'); pool.append(canvas);
        }
      }
      setNote('Circa 5 cm hoge letters op een voorbeeldjas van circa 95 cm. ' + (layout.rows > 1 ? layout.rows + ' regels; de letters blijven even groot. ' : '') + 'Indruk van de plaatsing, geen pasgarantie.');
    }

    async function paint(text) {
      const version = ++generation;
      paintJacket(text, version);
      preview.replaceChildren(); mini.replaceChildren();
      preview.setAttribute('aria-label', 'Losse letters voor ' + text);
      const elements = [...text].map(letter => {
        const placeholder = document.createElement('span');
        placeholder.className = letter === ' ' ? 'ef-name__space' : 'ef-name__fallback';
        if (letter !== ' ') { placeholder.textContent = letter; placeholder.title = 'Letterafbeelding wordt geladen'; }
        preview.append(placeholder);
        return { letter, placeholder };
      });
      if (!text) { const hint = document.createElement('p'); hint.textContent = 'Typ je tekst om de letters te bekijken.'; preview.append(hint); return; }
      await Promise.all(elements.map(async ({ letter, placeholder }) => {
        if (!/[A-Z]/.test(letter)) return;
        const p = config.products.find(p => p.letter === letter);
        if (!p || !p.image) { placeholder.title = 'Geen productafbeelding beschikbaar'; return; }
        try {
          const source = await loadPatch(p.image);
          if (generation !== version || !root.isConnected) return;
          const canvas = cloneCanvas(source); canvas.setAttribute('aria-hidden', 'true');
          placeholder.replaceWith(canvas);
        } catch (_) { if (generation === version) placeholder.title = 'Afbeelding niet geladen; dit is alleen een tekstplaceholder'; }
      }));
      if (generation !== version || !root.isConnected) return;
      for (const child of preview.children) {
        if (child.tagName === 'CANVAS') {
          const canvas = cloneCanvas(child); canvas.style.width = (canvas.width / canvas.height * 30) + 'px'; mini.append(canvas);
        }
      }
    }
    function render(redraw) {
      state = model(input.value, config, cartItems);
      const counts = $('[data-counts]'); counts.replaceChildren();
      const label = document.createElement('strong'); label.textContent = state.count + ' letters'; counts.append(label, ' · ');
      for (const [letter, quantity] of Object.entries(state.counts)) {
        const p = config.products.find(p => p.letter === letter);
        const element = document.createElement(p ? 'a' : 'span');
        element.textContent = letter + ' × ' + quantity;
        if (p) element.href = p.url;
        counts.append(element);
      }
      const priceComplete = state.count > 0 && state.lines.reduce((sum, line) => sum + line.quantity, 0) === state.count;
      $('[data-total]').textContent = priceComplete ? (state.tier.rate ? 'circa ' : '') + money(state.estimated) : '—';
      $('[data-before]').hidden = !state.tier.rate || !priceComplete;
      $('[data-before]').textContent = money(state.subtotal);
      $('[data-saving]').hidden = !state.tier.rate || !priceComplete;
      $('[data-saving]').textContent = state.tier.rate + '% voordeel';
      $('[data-price-note]').textContent = state.tier.rate ? 'Indicatie voor deze tekst. Shopify berekent de definitieve korting en afronding in je winkelwagen.' : 'Prijs voor jouw losse letters, exclusief verzending.';
      $('[data-validation]').textContent = state.errors.join(' ');
      const delivery = $('[data-delivery]'); delivery.hidden = !state.delayed.length;
      delivery.textContent = 'Jouw tekst komt eraan! Voor letter' + (state.delayed.length > 1 ? 's ' : ' ') + state.delayed.join(', ') + ' is nabestellen nodig: levertijd ' + config.leadDays + ' dagen. De definitieve voorraad wordt bij bestellen gecontroleerd.';
      $('[data-sticky-total]').textContent = priceComplete ? (state.tier.rate ? 'circa ' : '') + money(state.estimated) : '—';
      $('[data-sticky-count]').textContent = state.count + ' losse letters';
      root.querySelectorAll('[data-tier]').forEach(el => el.classList.toggle('on', Number(el.dataset.tier) === state.tier.minimum));
      root.querySelectorAll('[data-example]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.example === state.text)));
      buttons.forEach(button => { button.disabled = !state.valid || busy || locked; button.textContent = busy ? 'EVEN TOEVOEGEN…' : (button === buttons[0] ? 'VOEG MIJN TEKST TOE →' : 'TOEVOEGEN →'); });
      if (redraw) paint(state.text.slice(0, 120));
      setSticky();
    }
    async function getCart() {
      const response = await fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Winkelwagen kon niet worden gecontroleerd. Probeer opnieuw.');
      return response.json();
    }
    root.querySelectorAll('.ef-name__jacket-image').forEach(image => image.addEventListener('error', () => {
      root.querySelectorAll('[data-jacket-note]').forEach(note => { note.textContent = 'De jasfoto kon niet worden geladen. Je kunt hieronder je losse letters bekijken.'; });
    }));
    async function add() {
      if (busy || locked || !state.valid) return;
      busy = true; render(false); input.disabled = true;
      root.querySelectorAll('[data-example]').forEach(el => { el.disabled = true; });
      $('[data-status]').textContent = 'We verzamelen jouw letters…';
      let submitted = false;
      try {
        const cart = await getCart(); cartItems = cart.items || []; render(false);
        if (!state.valid) { $('[data-status]').textContent = 'Controleer de melding bij je tekst.'; return; }
        const items = state.lines.map(line => ({ id: line.product.id, quantity: line.quantity, properties: { 'Jouw tekst': state.text, 'Samenstelling': 'Losse strijkletters goud-wit' } }));
        submitted = true;
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Shopify kon de letters niet allemaal toevoegen.');
        $('[data-status]').textContent = 'Je letters zijn toegevoegd. Naar je winkelwagen…';
        locked = true; global.location.assign(cartUrl);
      } catch (error) {
        if (submitted) {
          locked = true; $('[data-cart-link]').hidden = false;
          $('[data-status]').textContent = error.message + ' Controleer eerst je winkelwagen voordat je opnieuw bestelt; er kunnen al letters zijn toegevoegd.';
        } else $('[data-status]').textContent = error.message;
      } finally {
        busy = false; input.disabled = false;
        root.querySelectorAll('[data-example]').forEach(el => { el.disabled = false; }); render(false);
      }
    }
    input.value = config.initial || '';
    input.addEventListener('input', () => { $('[data-status]').textContent = ''; render(true); });
    root.querySelectorAll('[data-example]').forEach(button => button.addEventListener('click', () => { if (busy) return; input.value = button.dataset.example; render(true); }));
    buttons.forEach(button => button.addEventListener('click', add));
    render(true);
    getCart().then(cart => { if (!busy && !locked && root.isConnected) { cartItems = cart.items || []; render(false); } }).catch(() => {});
    root._efCleanup = () => { generation++; if (observer) observer.disconnect(); };
  }
  function scan(container) { container.querySelectorAll('[data-ef-name]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ef-name]').forEach(root => { if (root._efCleanup) root._efCleanup(); }));
})(typeof window !== 'undefined' ? window : globalThis);